module.exports = __webpack_public_path__ + "img/karyawan.9ce6bca6.jpg";